
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.568 17.026a3.06 3.06 0 11-4.779 0l.002-.003s1.063-1.422 1.884-2.428a.646.646 0 011.007 0 86.617 86.617 0 011.888 2.431h-.002zM10.975 2.575a1 1 0 00-1.414 0L7.439 4.697l3.3 3.3a2 2 0 011.932 3.346 2 2 0 01-3.346-1.932l-3.3-3.3L7.44 4.697 5.318 2.575A1 1 0 003.904 3.99L6.025 6.11 2.49 9.646a3 3 0 000 4.243l4.95 4.95a3 3 0 004.242 0l7.071-7.071a1 1 0 000-1.415l-7.778-7.778z"}})])
          )
        }
      }
    